import { useState, useEffect } from 'react';

import { dataGridPremiumColumns } from '../../utils/helper';
import { MainCategoryOption, SubCategoryOption } from '../../config/absence';
import { DataGridIdentifiers, DatagridPremiumUi } from '../Interface';
import employeeAbsenceService from '../../service/employeeAbsence.service';

const EmployeeAbsenceReports = ({
  refetch,
  values,
  viewField,
  operatorsDisabled,
  rowSelection,
  autoCompleteOptions,
}) => {
  const { refetchTable, setRefetchTable } = refetch;
  const { setSelectedValues } = values;
  const { rowSelectionModel, setRowSelectionModel } = rowSelection;

  const [reports, setReports] = useState({ rows: [], rowCount: 0 });

  const initialState = {
    filter: { filterModel: { items: [], logicOperator: 'and' } },
    sorting: {
      sortModel: [{ field: 'startDate', sort: 'desc' }],
    },
    pagination: {
      paginationModel: {
        pageSize: 25,
        page: 0,
      },
    },
    density: 'compact',
  };

  useEffect(() => {
    if (operatorsDisabled) {
      setRowSelectionModel([]);
    }
  }, [operatorsDisabled]);

  const getList = (gridState) => {
    employeeAbsenceService.getAbsences(gridState).then((data) => {
      setReports(data);
    });
  };

  const columns = dataGridPremiumColumns([
    {
      field: 'startDate',
      type: 'date',
      headerName: 'Kezdő dátum',
      valueGetter: (_data, row) => {
        return new Date(row.startDate);
      },
    },
    {
      field: 'endDate',
      type: 'date',
      headerName: 'Befejező dátum',
      valueGetter: (_data, row) => {
        return new Date(row.endDate);
      },
    },
    {
      field: 'employeeId',
      headerName: 'Dolgozó',
      type: 'singleSelect',
      valueOptions: autoCompleteOptions.employee,
      renderCell: (params) => {
        return params.row.employee?.name;
      },
    },
    {
      field: 'mainCategory',
      headerName: 'Főkategória',
      type: 'singleSelect',
      valueOptions: MainCategoryOption,
    },
    {
      field: 'subCategory',
      headerName: 'Alkategória',
      type: 'singleSelect',
      valueOptions: Object.values(SubCategoryOption).flat(),
    },
    {
      field: 'approverId',
      headerName: 'Engedélyező',
      type: 'singleSelect',
      valueOptions: autoCompleteOptions.user,
      renderCell: (params) => {
        return params.row.approver?.nickName;
      },
    },
  ]);

  return (
    <DatagridPremiumUi
      datagridIdentifier={DataGridIdentifiers.EmployeeAbsenceReports}
      datagridInitialState={initialState}
      dataLoader={getList}
      rows={reports.rows}
      refetch={{ refetchTable, setRefetchTable }}
      rowCount={reports.rowCount}
      columns={columns}
      onRowClick={(rowData) => {
        if (!viewField) return;
        setSelectedValues(rowData.row);
      }}
      paginationAndfilterMode="server"
      onRowSelectionModelChange={(newRowSelectionModel) => {
        setRowSelectionModel(newRowSelectionModel);
      }}
      rowSelectionModel={rowSelectionModel}
      disableRowSelectionOnClick={!viewField}
    />
  );
};

export default EmployeeAbsenceReports;
